import { SET_CALLS } from 'logic/redux/actions/calls';

const initialState = {
  items: [],
  count: 0
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CALLS:
      return {
        ...state,
        items: action.data,
        count: action.count
      };
    default:
      return state;
  }
}

const getStateBase = (state) => state.calls;

export const getCalls = (state) => getStateBase(state).items;
export const getCount = (state) => getStateBase(state).count;
